module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-lgrey",
    attrs: {
      "id": "k2uprights"
    }
  }, [_c('tooltips', {
    attrs: {
      "tippy": _vm.tooltipsData,
      "box": _vm.tooltipsBox
    }
  }, [_c('room', {
    staticStyle: {
      "pointer-events": "none"
    }
  }, [(_vm.tooltipsUpright) ? _c('k2upright', {
    attrs: {
      "data": _vm.tooltipsUpright,
      "show-edit": true,
      "width": _vm.widths[_vm.tooltipsUpright.width],
      "is-disabled": false,
      "show-add": true
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('room', {
    attrs: {
      "bg-line-text": "bg-lgrey"
    }
  }, _vm._l((_vm.uprights), function(upright, up_index) {
    return _c('k2upright', {
      key: 'up' + up_index,
      staticClass: "k2_upright",
      attrs: {
        "width": _vm.widths[upright.width],
        "is-disabled": _vm.currentIndex !== null && _vm.currentIndex !== up_index,
        "show-edit": true,
        "show-add": !_vm.room_is_full && up_index === _vm.uprights.length - 1
      },
      on: {
        "add": function($event) {
          _vm.addNewUpright()
        },
        "edit": function($event) {
          _vm.onUprightClick(up_index)
        }
      }
    }, _vm._l((_vm.objects()[up_index]), function(object, obj_index) {
      return _c('k2element', {
        key: ("obj-" + up_index + "-" + obj_index),
        attrs: {
          "is-disabled": true,
          "is-editing": false,
          "pos-slot": object.slot,
          "img": _vm.objectRightWidth(object, up_index).frontal_inactive
        }
      })
    }))
  })), _vm._v(" "), _c('editbar', {
    attrs: {
      "buttons": _vm.editButtons,
      "is-visible": _vm.editBarIsVisible,
      "show-delete": _vm.uprights.length > 1
    },
    on: {
      "delete": function($event) {
        _vm.removeConfirmUpright(_vm.currentIndex)
      },
      "confirm": _vm.hideEditBar
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb8719a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/uprights/K2.vue
// module id = 665
// module chunks = 0